import { Component } from '@angular/core';

@Component({
  selector: 'app-sponsors',
  imports: [],
  standalone: true,
  templateUrl: './sponsors.html',
  styleUrl: './sponsors.scss',
})
export class Sponsors {}
